import React__default, { createContext } from 'react';

const PortalContext = /*#__PURE__*/createContext(undefined);
/**
 * The PortalContextProvider allows applications to specify a element the descendants popover/popper
 *  will be rended into.
 */
const PortalContextProvider = ({
  portalElementRef,
  children
}) => /*#__PURE__*/React__default.createElement(PortalContext.Provider, {
  value: portalElementRef
}, children);
PortalContextProvider.displayName = 'PortalContextProvider';

export { PortalContextProvider as P, PortalContext as a };
//# sourceMappingURL=PortalContext-CNkIMMvm.js.map
